// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"45ecf08a","713":"779302d4","830":"493bf9ec","846":"8ea024c5"}[chunkId] + ".chunk.js";
};